import React, {useEffect, useState} from "react";
import PropTypes from "prop-types";
import { DataGridItem } from "components/data-grid";
import { injectIntl } from "react-intl";
import { CardWithDelete } from "components/card";
import TextField from "@material-ui/core/TextField";
import InputLabel from "@material-ui/core/InputLabel";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import FormControl from "@material-ui/core/FormControl";
import { getAvailableLocales } from "components/i18n-provider";

const EmailReceiptApiForm = ({ index, collectionName = "emailReceipts", onDelete, intl, register, classes, watch }) => {
  const locale = watch(`${collectionName}[${index}].locale`);

  const [availableLocales, setAvailableLocales] = useState([]);

  useEffect(
      () => {
        let canceled = false;

        getAvailableLocales().then(locales => {
          if (!canceled) {
            setAvailableLocales(
                locales.map(value => ({ label: intl.formatMessage({ id: `common.locale.in.${value}` }), value })),
            );
          }
        });

        return () => (canceled = true);
      },
      [intl],
  );

  return <CardWithDelete onDelete={onDelete}>
    <DataGridItem>
      <TextField
          {...register(`emailReceipts[${index}].email`)}
          id={`emailReceipts[${index}].email`}
          type="text"
          placeholder={intl.formatMessage({id: "event.emailReceipt.email"})}
          label={intl.formatMessage({id: "event.emailReceipt.email"})}
          //error={!!errors.description}
          //helperText={errors.description?.message}
          className={classes.fullWidth}
      />
    </DataGridItem>
    <DataGridItem>
      <FormControl className={classes.fullWidth}>
        <InputLabel
            id={`emailReceipts[${index}].locale-label`}>{intl.formatMessage({id: "event.emailReceipt.locale"})}</InputLabel>
        <Select {...register(`emailReceipts[${index}].locale`)}
                value={locale}
                getLabelFromElement={item => item.label}
                getValueFromElement={item => item.value}
                id={`emailReceipts[${index}].locale-select`}>
          {availableLocales?.map((l) => (
              <MenuItem key={l.value} value={l.value}>
                {l.label}
              </MenuItem>))}
        </Select>
      </FormControl>
    </DataGridItem>
  </CardWithDelete>
}


EmailReceiptApiForm.propTypes = {
  /**
   * Lista de locales disponibles en la aplicación
   */
  availableLocales: PropTypes.array,
  /**
   * Índice del elemento en la colección
   */
  index: PropTypes.number,
  /**
   * Nombre de la colección
   */
  collectionName: PropTypes.string,
  /**
   * Función que se invoca al modificar algún valor
   */
  onChange: PropTypes.func,
  /**
   * Función que se invoca al eliminar el contacto del formulario
   */
  onDelete: PropTypes.func,
  /**
   * Objeto con los valores que se quieren representar
   */
  element: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
};

export default injectIntl(EmailReceiptApiForm);
